import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrlApi } from "../../proxy";
import axios, { AxiosResponse } from "axios";

export const toGetAboutUs = createAsyncThunk<AxiosResponse<any, any>, string>(
  "about-us/toGetAboutUs",
  async (lang) => {
    try {
      const response = await axios.get(
        `${baseUrlApi}portal/aboutus?lang=${lang}`
      );
      return response;
    } catch (error) {
      throw error;
    }
  },
  {
    condition: (_, { getState }) => {
      const state = getState() as {
        about?: { aboutus?: { status?: string } };
      };
      const status = state.about?.aboutus?.status;
      return status !== "loading" && status !== "succedded";
    },
  }
);
